"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoImageIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** NoImageIcon */
var NoImageIcon = function NoImageIcon(props) {
  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 12 18"
  }), _react.default.createElement("title", null, "no image"), _react.default.createElement("path", {
    d: "M2.62263891,12 L8.16110045,4 L1,4 L1,12 L2.62263891,12 Z M3.83889955,12 L11,12 L11,4 L9.37736109,4 L3.83889955,12 Z M8.85340814,3 L10.3735089,0.804298915 L11.1957011,1.37350889 L10.0696688,3 L12,3 L12,13 L3.14659186,13 L1.62649111,15.1957011 L0.804298915,14.6264911 L1.93033122,13 L0,13 L0,3 L8.85340814,3 Z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M3,6 L3,10 L9,10 L9,6 L3,6 Z M2,5 L10,5 L10,11 L2,11 L2,5 Z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.NoImageIcon = NoImageIcon;
NoImageIcon.displayName = "NoImageIcon";
//# sourceMappingURL=NoImageIcon.js.map